import { render, staticRenderFns } from "./Brands.vue?vue&type=template&id=c8efc3a2&scoped=true&"
import script from "./Brands.vue?vue&type=script&lang=js&"
export * from "./Brands.vue?vue&type=script&lang=js&"
import style0 from "./Brands.vue?vue&type=style&index=0&id=c8efc3a2&lang=scss&scoped=true&"
import style1 from "./Brands.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8efc3a2",
  null
  
)

export default component.exports